import { useEditorEventCallback } from "@handlewithcare/react-prosemirror";

import { makeToast } from "@moment/design-system/Toast";

import { useDeleteConfirmModal } from "~/components/common/useDeleteConfirmModal";
import { useSendToCodeEditorStore } from "~/state/machines/code-editor";

import { findDescendants } from "../easel/prosemirror/helpers/findDescendants";
import { useEaselCurrentPage } from "./useEaselCurrentPage";

export function useEaselDeleteComputeCell() {
	const { deleteConfirmation } = useDeleteConfirmModal();
	const send = useSendToCodeEditorStore();
	const currentPage = useEaselCurrentPage();

	return useEditorEventCallback(async (view, cellID: string) => {
		const [cell] = findDescendants(view.state.doc, (node) => node.attrs["id"] === cellID);
		const cellName = cell?.node.attrs["cellName"];

		const confirmStatus = await deleteConfirmation({
			headingTitle: "Delete cell",
			name: cellName || "this cell",
		});
		if (!confirmStatus) {
			return;
		}

		if (!cell) {
			makeToast({
				message: `Unable to delete cell with id ${cellID}`,
				variant: "error",
				timer: "timed-dismissible",
			});

			return;
		}

		send({ type: "closeTab", cellID, activePageID: currentPage?.id });

		let tr = view.state.tr;
		tr = tr.delete(cell.pos, cell.pos + cell.node.nodeSize);

		view.dispatch(tr.scrollIntoView());
		view.focus();

		makeToast({
			message: `Deleted cell`,
			variant: "success",
			timer: "timed-dismissible",
		});
	});
}
